module.exports = __webpack_public_path__ + "0cc028ac4777a142b06c2f99d2d2df99.png";